"use client";

import { kratos, useForgotPasswordFormQuery } from "../..";

import { useMutation } from "@tanstack/react-query";

export type UseForgotPasswordMutationPayload = {
  email: string;
};

export const useForgotPasswordMutation = () => {
  const { data: recoveryData, refetch } = useForgotPasswordFormQuery();

  const mutation = useMutation(
    async (data: UseForgotPasswordMutationPayload) => {
      if (!recoveryData) {
        await refetch();

        throw new Error("Data sudah tidak berlaku, harap kirim ulang.");
      }

      return kratos.updateRecoveryFlow({
        flow: recoveryData.id,
        updateRecoveryFlowBody: {
          csrf_token: recoveryData.csrfToken,
          method: "link",
          email: data.email,
        },
      });
    }
  );

  return {
    ...mutation,
    recoveryData,
    refetch,
  };
};

export default useForgotPasswordMutation;
